
import Vue from 'vue';
import VueI18n from 'vue-i18n';
// 假设 getLanguageInfo 是你在 api 模块中定义的请求方法
import { getLanguageInfo } from '@/api/Add-Language.js'; // 请根据实际路径调整

Vue.use(VueI18n);



// 支持的语言列表（可与组件共享）
export const SUPPORTED_LANGS = {
  zh_CN: { label: '中文', code: 'zh_CN' },
  en_US: { label: 'English', code: 'en_US' },
  ja: { label: '日本語', code: 'ja' }
};

const i18n = new VueI18n({
  locale: 'ja', // 初始值，后面会从 localStorage 或浏览器语言设置
  fallbackLocale: 'ja',
  messages: {},
  silentTranslationWarn: true // 可选：减少警告
});

// 扩展 $tr 方法用于 picklist
Vue.prototype.$tr = function (key) {
  const msg = this.$t(`picklist.${key}`);
  return msg === key || msg === `picklist.${key}` ? key : msg;
};

// 缓存已加载的语言包，防止重复请求
const langCache = new Map();
let loadingPromise = null;

i18n.loadLanguageAsync = async function (requestParams) {
  const key = JSON.stringify(requestParams);

  // 如果已加载过，跳过
  if (langCache.has(key)) {
    console.log('[i18n] 已缓存，跳过请求:', requestParams);
    return;
  }

  // 防止并发重复请求
  if (loadingPromise && langCache.pendingKey === key) {
    await loadingPromise;
    return;
  }

  langCache.pendingKey = key;
  loadingPromise = (async () => {
    try {
      const response = await getLanguageInfo(requestParams); // 替换为你的 API 
      // 检查 response 是否存在，防止 401 时 response 为 undefined
      if (!response) {
        this.locale = 'ja';
        return;
      }
      const apiData = response.data;

      if (!apiData || apiData.status !== 1 || !apiData.data) {
      this.locale = 'ja';
        return;
      }

      const { label, picklist } = apiData.data;
      const messages = {};

      Object.keys(label).forEach(lang => {
        messages[lang] = {
          ...label[lang],
          picklist: picklist[lang] || {}
        };
      });

      // 合并到 i18n（增量更新）
      Object.keys(messages).forEach(lang => {
        this.mergeLocaleMessage(lang, messages[lang]);
      });

      // 设置当前语言
      const savedLang = localStorage.getItem('lang');
      const browserLang = navigator.language.includes('zh') ? 'zh_CN' :
        navigator.language.startsWith('ja') ? 'ja' : 'en_US';

      const finalLang = savedLang && messages[savedLang]
        ? savedLang
        : (messages[browserLang] ? browserLang : 'ja');

      this.locale = finalLang; // ✅ 关键：设置当前语言

      // 标记已完成初始化
      this.localeSet = true;

      // 缓存结果
      langCache.set(key, messages);

    } catch (error) {
      console.error('[i18n] 加载失败:', error);
      this.locale = 'ja';
    } finally {
      loadingPromise = null;
      langCache.pendingKey = undefined;
    }
  })();

  await loadingPromise;
};

export default i18n;